// THE header of the unscheduled-visit flow (KAN-765). Steps 1-2 (the full-screen
// overlay) and step 3 (the Log Job route) both render THIS component with the
// same layout, so the header sits in the identical spot on every step and the
// Reason -> Log Job hand-off (and Back) never moves it. Only the step, the back
// chevron and the close handler differ; the geometry is the kit header's.
import { useIntl } from 'react-intl';
import { Briefcase } from 'lucide-react';
import { FullScreenFlowHeader } from '../../common/fullscreenFlow';
import { unscheduledFlowSteps } from './unscheduledFlowShared';

/**
 * @param {object} props
 * @param {'phone'|'tablet'|'desktop'} props.layout
 * @param {1|2|3} props.currentStep
 * @param {() => void} [props.onBack]
 * @param {() => void} props.onClose
 * @param {boolean} [props.closeDisabled]
 * @param {string} [props.testId]
 */
export default function UnscheduledFlowHeader({
  layout, currentStep, onBack, onClose, closeDisabled = false, testId = 'unscheduled-wizard-header',
}) {
  const intl = useIntl();
  return (
    <FullScreenFlowHeader
      layout={layout}
      icon={<Briefcase size={18} />}
      title={intl.formatMessage({ id: 'worker.unscheduled.modalTitle', defaultMessage: 'Log unscheduled visit' })}
      areaLabel={intl.formatMessage({ id: 'nav.route', defaultMessage: 'Route' })}
      onBack={onBack}
      onClose={onClose}
      closeDisabled={closeDisabled}
      closeAriaLabel={intl.formatMessage({ id: 'common.close', defaultMessage: 'Close' })}
      backAriaLabel={intl.formatMessage({ id: 'common.back', defaultMessage: 'Back' })}
      steps={unscheduledFlowSteps(intl)}
      currentStep={currentStep}
      stepperAriaLabel={intl.formatMessage({ id: 'worker.unscheduled.stepperAria', defaultMessage: 'Unscheduled visit steps' })}
      testId={testId}
    />
  );
}
